<template>
  <section class="intro">
    <div class="contain">
      <img class="icon" :src="require('@/assets/img/' + icon + '.svg')" />
      <h1>
        {{ title }}
        <span class="dot">!</span>
      </h1>
      <p>{{ body }}</p>
      <div class="btns center">
        <button @click="$emit('next')" class="btn">{{ btn_text }}</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Section",
  props: ["title", "body", "icon", "btn_text"],
  components: {},
  data() {
    return {};
  },
  mounted() {},
  created() {},
  firestore() {
    return {};
  },
  methods: {},
  watch: {}
};
</script>

<style lang="scss">
.intro {
  height: auto;
  min-height: calc(100vh - 124px) !important;
  background: rgba(11, 110, 251, 0.08);
  width: 100%;
  text-align: center;
  .contain {
    display: flex;
    justify-content: center;
    flex-direction: column;
    min-height: calc(100vh - 124px) !important;
    max-width: 700px;
    .icon {
      height: 70px;
      margin-bottom: 30px;
    }
    h1 {
      font-size: 50px;
    }
    p {
      font-size: 18px;
    }
  }
}
</style>
